export const generateExample = () => undefined;
export const getPackageInfo = () => ({});
export const validateBaseMessage = () => null;
//# sourceMappingURL=index.js.map